import {
  Box, ButtonBase, makeStyles, withStyles,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';

import MagicCodeField from '../../../menu/containers/MagicCodeField';
import ProgressBackdrop from '../../../preorder/components/ProgressBackdrop';
import configJson from '../../../preorder/configs/config';
import { COUPON_FILTER_TYPE } from '../../const';
import CheckoutCompletedDialog from '../../containers/coupon/CheckoutCompletedDialog';
import VoucherShopItemCheckoutModal from '../../containers/coupon/VoucherShopItemCheckoutModal';
import Dialog from './Dialog';
import Item from './Item';
import VoucherShopItem from './VoucherShopItem';

const StyledButton = withStyles((theme) => ({
  root: (props) => ({
    backgroundColor: props.isActived ? 'black' : '#e5e5e5',
    borderRadius: 8,
    color: props.isActived ? 'white' : 'black',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    fontSize: 18,
    fontWeight: 'bold',
    padding: theme.spacing(0.5, 0),

    [theme.breakpoints.up('sm')]: {
      maxWidth: 184,
    },
  }),
}))(ButtonBase);

const ItemContainer = withStyles((theme) => ({
  root: {
    flexBasis: 0,
    '&+&': {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      flexBasis: '49.5%',
      marginTop: theme.spacing(2),
      '&+&': {
        marginTop: theme.spacing(2),
      },
    },
  },
}))(Box);

const useLoadingItemStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  imageContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    maxWidth: 180,
    position: 'relative',
  },
  image: {
    top: 0,
    left: 0,
    position: 'absolute',
    flexGrow: 1,
    paddingTop: '60%',
    height: '100%',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    marginLeft: theme.spacing(1),
  },
}));

const LoadingItem = () => {
  const classes = useLoadingItemStyle();

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <Skeleton variant="rect" className={classes.image} />
      </div>
      <div className={classes.content}>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  voucherShopItemsContainer: {
    '&>*+*': {
      marginTop: theme.spacing(1.5),
    },
  },
}));

export default ({
  afterSendButtonClick,
  coupons,
  customerCouponFrontItems,
  dialogData,
  filterType,
  isDialoglOpen,
  isInited,
  isLoading,
  onDialogCancelButtonClick,
  onDialogOkButtonClick,
  onFilterButtonCLick,
  onItmeClick,
  voucherShopItems,
}) => {
  const classes = useStyles();
  const [
    isVoucherShopItemCheckoutModalOpen,
    setIsVoucherShopItemCheckoutModalOpen,
  ] = useState(false);
  const [voucherShopItemIdToCheckout, setVoucherShopItemIdToCheckout] = useState('');

  const onBuyButtonClick = (voucherShopItemId) => {
    setIsVoucherShopItemCheckoutModalOpen(true);
    setVoucherShopItemIdToCheckout(voucherShopItemId);
  };

  const onVoucherShopItemModalCancelButtonClick = () => {
    setIsVoucherShopItemCheckoutModalOpen(false);
    setVoucherShopItemIdToCheckout('');
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      position="relative"
      px={1.5}
      pt={{ sm: 8 }}
    >
      <VoucherShopItemCheckoutModal
        id={voucherShopItemIdToCheckout}
        onCancelButtonClick={onVoucherShopItemModalCancelButtonClick}
        isOpen={isVoucherShopItemCheckoutModalOpen}
      />
      <Dialog
        isOpen={isDialoglOpen}
        data={dialogData}
        onOkButtonClick={onDialogOkButtonClick}
        onCancelButtonClick={onDialogCancelButtonClick}
      />
      <CheckoutCompletedDialog />
      <ProgressBackdrop isShow={isLoading} />
      <MagicCodeField afterSendButtonClick={afterSendButtonClick} />
      <div className={classes.voucherShopItemsContainer}>
        {(voucherShopItems || []).map((item) => {
          const { id } = item || {};

          return (
            <VoucherShopItem
              data={item}
              key={id}
              onBuyButtonClick={onBuyButtonClick}
            />
          );
        })}
      </div>
      <Box display="flex" alignItems="center" mt={2.5}>
        <Box mr={2} display={{ xs: 'none', sm: 'block' }} fontWeight="bold" fontSize={18}>
          我的優惠券
        </Box>
        <StyledButton
          isActived={filterType === COUPON_FILTER_TYPE.VALID}
          onClick={() => {
            onFilterButtonCLick(COUPON_FILTER_TYPE.VALID);
          }}
        >
          可使用優惠券

        </StyledButton>
        <StyledButton
          isActived={filterType === COUPON_FILTER_TYPE.INVALID}
          style={{ marginLeft: 8 }}
          onClick={() => {
            onFilterButtonCLick(COUPON_FILTER_TYPE.INVALID);
          }}
        >
          過期/已使用優惠券

        </StyledButton>
      </Box>
      {
      (() => {
        if (configJson.modules?.['coupon_text'] === false) return null;

        return (
          <Box fontSize={14} fontWeight="bold" mt={1.5} lineHeight={1.8}>
            <Box>【機台購餐】</Box>
            <Box>只要符合優惠卷使用條件，將自動在關門結帳時自動套用，可點選特定優惠券作為下次消費優先使用。</Box>
            <Box>【線上預訂】</Box>
            <Box>於結帳流程選擇套用優惠券，方可進行折抵。</Box>
          </Box>
        );
      })()
      }
      <Box
        mt={{
          xs: 1.5,
          sm: 0,
        }}
        display="flex"
        flexDirection={{
          xs: 'column',
          sm: 'row',
        }}
        alignItems="stretch"
        justifyContent={{
          sm: 'space-between',
        }}
        flexWrap={{
          xs: 'nowrap',
          sm: 'wrap',
        }}
      >
        {customerCouponFrontItems.map((coupon) => {
          const { title, url } = coupon;
          return (
            <ItemContainer key={title}>
              <Item
                isAd
                onClick={() => {
                  if (url) window.open(url, '_blank');
                }}
                {...coupon}
              />
            </ItemContainer>
          );
        })}
        {(isLoading && !isInited) && (
          [1, 2, 3, 4].map((key) => (
            <ItemContainer key={key}>
              <LoadingItem />
            </ItemContainer>
          ))
        )}
        {coupons.map((coupon, index) => {
          const { id } = coupon;
          return (
            <ItemContainer key={id}>
              <Item
                {...coupon}
                index={filterType === COUPON_FILTER_TYPE.VALID ? index + 1 : 0}
                disabled={filterType === COUPON_FILTER_TYPE.INVALID}
                onClick={onItmeClick}
              />
            </ItemContainer>
          );
        })}
      </Box>
      {isInited && isEmpty(coupons)
      && <Box textAlign="center" mt={4} color="#2f2f2f" fontSize={24}>您沒有任何的優惠券</Box>}
    </Box>
  );
};
